/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { CollectionView } from 'backbone.marionette';

import SelectionItemView from '../SelectionItemView';

import tmplSelectionCollectionView from './SelectionCollectionView.hbs';

const SelectionCollectionView = CollectionView.extend({
  className: 'selection-collectionview',

  childViewContainer: '.child-view-container',

  template: tmplSelectionCollectionView,

  childView: SelectionItemView,

  childViewEvents: {
    'checkbox:changed': 'onItemChanged'
  },

  childViewTriggers: {
    'checkbox:changed': 'checkbox:changed'
  },

  onRender() {},

  setChecked(ids) {
    _.each(ids, (id) => {
      const cv = this.children.find((cv) => cv.model.get('id') === id);
      cv?.setChecked(true);
    });
  },

  setUnchecked(ids) {
    _.each(ids, (id) => {
      const cv = this.children.find((cv) => cv.model.get('id') === id);
      cv?.setChecked(false);
    });
  },

  setOnlyChecked(ids) {
    this.setAllUnchecked();
    this.setChecked(ids);
  },

  setAllChecked() {
    this.children.each((itemView) => {
      itemView.setChecked(true);
    });
  },

  setAllUnchecked() {
    this.children.each((itemView) => {
      itemView.setChecked(false);
    });
  },

  getChecked() {
    const checkedModels = _.filter(this.collection.models, (model) => {
      return model.get('isChecked');
    });
    return checkedModels;
  },

  setDisabled(ids) {
    _.each(ids, (id) => {
      const cv = this.children.find((cv) => cv.model.get('id') === id);
      cv?.setDisabled(true);
    });
  }
});

export default SelectionCollectionView;
